import { AppState } from '../AppTypes';
import { Site } from 'sections/client-management/entities';

export const _isSiteAuthorised = (state: AppState) => {
  return (siteId: string) => {
    const sites = state?.clients?.sites;
    const accessLevel = state?.userInfo?.accessLevel;
    const brandIds = state?.userInfo?.brandIds;
    const siteIds = state?.userInfo?.siteIds;

    if (accessLevel === 'SaleCycle') {
      return true;
    } else if (accessLevel === 'Site' || accessLevel === 'MultiSite') {
      return siteIds && siteIds.includes(siteId);
    } else if (accessLevel === 'Brand') {
      const site = sites.find((s: Site) => s.id === siteId);
      return site && site.brandId === brandIds[0];
    } else {
      return false;
    }
  };
};
